import React, {
  useEffect,
  useState,
} from "react";

import { useAdminScope } from "../../context/AdminScopeContext";
import { listActivities } from "../../services/activityApi";
import {
  AdminFilterSelect,
} from "./section_engine";


export default function AdminActivityScopeSelector() {
  const {
    selectedCompanyUuid,
    selectedActivityUuid,
    setSelectedActivity,
    clearSelectedActivity,
  } = useAdminScope();

  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;

    if (!selectedCompanyUuid) {
      setActivities([]);
      setError("");
      return () => {
        active = false;
      };
    }

    setLoading(true);
    setError("");

    listActivities({
      companyUuid: selectedCompanyUuid,
    })
      .then((response) => {
        if (!active) {
          return;
        }

        setActivities(
          response?.data?.activities ?? []
        );
      })
      .catch(() => {
        if (!active) {
          return;
        }

        setActivities([]);
        setError(
          "Impossible de charger les activités."
        );
      })
      .finally(() => {
        if (active) {
          setLoading(false);
        }
      });

    return () => {
      active = false;
    };
  }, [selectedCompanyUuid]);

  const handleChange = (event) => {
    const activityUuid = event.target.value;

    if (!activityUuid) {
      clearSelectedActivity();
      return;
    }

    const activity = activities.find(
      (candidate) =>
        String(candidate.uuid)
        === String(activityUuid)
    );

    if (!activity) {
      clearSelectedActivity();
      return;
    }

    setSelectedActivity(activity);
  };

  if (!selectedCompanyUuid) {
    return null;
  }

  return (
    <div className="admin-dashboard-activity-scope">
      <label htmlFor="admin-activity-scope-selector">
        <strong>Activité :</strong>
      </label>

      <AdminFilterSelect
        id="admin-activity-scope-selector"
        aria-label="Activité du scope administrateur"
        value={selectedActivityUuid || ""}
        onChange={handleChange}
        disabled={loading}
      >
        <option value="">
          {loading
            ? "Chargement des activités..."
            : "Sélectionner une activité"}
        </option>

        {activities.map((activity) => (
          <option
            key={activity.uuid}
            value={activity.uuid}
          >
            {activity.name || activity.uuid}
          </option>
        ))}
      </AdminFilterSelect>

      {error && (
        <span
          role="alert"
          className="admin-dashboard-activity-scope-error"
        >
          {error}
        </span>
      )}
    </div>
  );
}
